import ReactGA from 'react-ga';

class TrackingService {
  constructor() {
    ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_CODE ?? '');
  }

  trackEvent(category: string, action: string, label?: string, value?: number) {
    ReactGA.event({ category, action, label, value });
  }

  trackScreen(name: string) {
    ReactGA.set({ page: name }); // Update the user's current page
    ReactGA.pageview(name); // Record a pageview for the given page
  }

  trackModalView(name: string) {
    ReactGA.modalview(name);
  }

  setUserId(id: string) {
    ReactGA.set({
      userId: id,
    });
  }
}

export default TrackingService;
